class ScrollDrag extends HTMLElement {
  connectedCallback() {
    this.addEventListener('mousedown', this.start);
  }

  disconnectedCallback() {
    this.removeEventListener('mousedown', this.start);
    this.removeEventListener('mouseleave', this.end);
    this.removeEventListener('mouseup', this.end);
    this.removeEventListener('mousemove', this.move);
  }

  start = (evt) => {
    evt.preventDefault();
    this.classList.add('cursor-grabbing');
    this.startX = evt.pageX - this.offsetLeft;
    this.startScrollLeft = this.scrollLeft;
    this.addEventListener('mousemove', this.move);
    this.addEventListener('mouseleave', this.end);
    this.addEventListener('mouseup', this.end);
    this.isDragging = false;
  };

  move = (evt) => {
    evt.preventDefault();
    const move = evt.pageX - this.offsetLeft - this.startX;
    this.scrollLeft = this.startScrollLeft - move;
    this.isDragging = true;
  };

  end = () => {
    this.classList.remove('cursor-grabbing');
    this.removeEventListener('mousemove', this.move);
    this.removeEventListener('mouseleave', this.end);
    this.removeEventListener('mouseup', this.end);
  };
}

customElements.define('scroll-drag', ScrollDrag);
